<template>
	<div>
		<base-header class="pb-6 bg-light">
			<!-- Page header -->
			<b-row aling-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">HLR Restart</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>
		<b-container class="pt-5 w-50" style="min-width: max-content; max-width: 600px;">
			<b-card>
				<b-form>
					<b-row>
						<b-col>
							<p class="h3">Resart Target</p>
						</b-col>
						<b-col>
							<b-form-select id="target" class="text-center" v-model="target" :options="targetOptions" :state="!submitDisabled">
							</b-form-select>
						</b-col>
					</b-row>
					<b-row class="justify-content-center text-center mt-4">
						<span class="p-1 mx-2 bg-danger text-white">
							<p>
								<strong class="font-weight-600"><u>HLR Restart is a one way action!</u></strong> <br />
								Once started all carrier services will be restarted. HLR Restart can not be canceled once
								started.
							</p>
						</span>
					</b-row>
					<hr />
					<div class="mt-3 d-flex justify-content-between">
						<b-button variant="primary" :disabled="submitDisabled || loadingStatus" @click="sendRestart">
							Send Restart <i class="fas fa-power-off"></i>
						</b-button>
					</div>
				</b-form>
			</b-card>
		</b-container>
	</div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb.vue";
import swal from "sweetalert2";
import troubleshootingService from "../../../common/api-services/troubleshooting-service";
import initService from "../../../common/api-services/init-service";

export default {
	name: "",
	components: {
		RouteBreadCrumb,
	},
	mounted() {
		document.title = "Troubleshooting - HLR Restart";

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/restricted").catch(() => {});
		}
	},
	data() {
		return {
			target: null,
			loadingStatus: false,
			targetOptions: [
				{value: null, text: "- Select -"},
				{value: "All", text: "All"},
				{value: "RT-A", text: "RT-A"},
				{value: "RT-B", text: "RT-B"},
			],
		};
	},
	computed: {
		noAccess() {
			// Determine access based on menu link configuration
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		},
		submitDisabled() {
			return this.target === null;
		},
	},
	methods: {
		sendRestart(event) {
			event.preventDefault();
			swal.fire({
				title: `Are you sure you want to send an HLR Restart command to ${this.target}?`,
				text: `This action will restart all ${this.target} services and can NOT be canceled!`,
				showCloseButton: true,
				showCancelButton: true,
				confirmButtonText: "Restart",
				cancelButtonText: "Cancel",
				customClass: {
					cancelButton: 'order-1 mr-3',
					confirmButton: 'btn btn-danger order-2',
				},
			}).then(async result => {
				if (result.isConfirmed) {
					this.loadingStatus = true;
					await troubleshootingService.sendHlrRestart(this.target).then(res => {
						if (String(res.message).toLowerCase().includes("success")) {
							this.$toast.success(res.message);
						} else {
							this.$toast.error(res.message);
						}
					})
					.catch(err => {
						this.$toast.error(err.message);
					});
					this.loadingStatus = false;
				}
			});
		},
	},
};
</script>
